import { useInfiniteQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { campaignQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { CampaignTypeDTO } from "@/types/response/CampaignType";
import { PagedResponse } from "@/types/response/PagedResponse";

interface UseCampaignsInfiniteParams {
  clientId?: string;
  descending?: boolean;
  orderBy?: string;
  search?: string;
  includeIntegrations?: boolean;
  statuses?: string[];
}

export function useCampaignsInfinite(params: UseCampaignsInfiniteParams) {
  return useInfiniteQuery<PagedResponse<CampaignTypeDTO>, AxiosError>({
    queryKey: campaignQueryKeys.infinite(params),
    refetchOnMount: true,
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      instance
        .get<PagedResponse<CampaignTypeDTO>>("/api/v2/Campaigns", {
          params: {
            descending: params.descending,
            orderBy: params.orderBy,
            page: pageParam,
            pageSize: 100,
            clientId: params.clientId,
            search: params.search,
            includeIntegrations: params.includeIntegrations ?? false,
            statuses:
              params.statuses && params.statuses.length > 0
                ? params.statuses
                : undefined,
          },
        })
        .then((res) => res.data),
    getNextPageParam: (lastPage, allPages) => {
      const totalRecords = lastPage.totalRecords;
      const totalFetched = allPages.reduce(
        (acc, page) => acc + page.data.length,
        0
      );
      return totalFetched < totalRecords ? allPages.length + 1 : undefined;
    },
  });
}
